import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgEmailInbox({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M1 6.538l5.094 3.276a2.6 2.6 0 002.812 0L14 6.54v4.96a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 011 11.5V6.538zM12.5 3A1.5 1.5 0 0114 4.5v.613L8.258 8.805a1.4 1.4 0 01-1.515 0L1 5.112V4.5A1.5 1.5 0 012.5 3h10z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgEmailInbox.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgEmailInbox.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgEmailInbox svgRef={ref} {...props} />);
export default ForwardRef;
